module.exports = __webpack_public_path__ + "static/media/HB_cacaooats_sqaure.f83e3bdf.jpg";